// The agent registers one of two block-tool families depending on chat mode:
// pulse_block_preview chats get the create_persistable_* variants, every other
// chat gets the plain ones. Both emit <<BLOCK:name>> markers consumed by the
// same inline renderer, so any matcher must accept either family.
export const BLOCK_TOOLS = {
  CreateTableBlock: 'create_table_block',
  CreateChartBlock: 'create_chart_block',
  CreateNumberBlock: 'create_number_block',
  CreatePersistableTableBlock: 'create_persistable_table_block',
  CreatePersistableChartBlock: 'create_persistable_chart_block',
  CreatePersistableNumberBlock: 'create_persistable_number_block',
  CreatePersistableAgentBlock: 'create_persistable_agent_block',
} as const;

export const TABLE_BLOCK_TOOLS = [
  BLOCK_TOOLS.CreateTableBlock,
  BLOCK_TOOLS.CreatePersistableTableBlock,
];

export const CHART_BLOCK_TOOLS = [
  BLOCK_TOOLS.CreateChartBlock,
  BLOCK_TOOLS.CreatePersistableChartBlock,
];

export const NUMBER_BLOCK_TOOLS = [
  BLOCK_TOOLS.CreateNumberBlock,
  BLOCK_TOOLS.CreatePersistableNumberBlock,
];

// Agent/text output is accepted only by the Pulse edit-preview flow. Keep it
// out of the generic persistable matcher so ordinary previews remain SQL-backed.
export const PERSISTABLE_BLOCK_TOOLS = [
  BLOCK_TOOLS.CreatePersistableTableBlock,
  BLOCK_TOOLS.CreatePersistableChartBlock,
  BLOCK_TOOLS.CreatePersistableNumberBlock,
];

// Tool names arrive fully qualified (e.g. mcp__data_explorer__create_chart_block),
// so match on suffix. Each variant needs its own entry — note that
// 'create_persistable_chart_block' does not end with 'create_chart_block'.
const endsWithAny = (tool: string, suffixes: readonly string[]): boolean =>
  suffixes.some(suffix => tool.endsWith(suffix));

export const isTableBlockTool = (tool: string): boolean =>
  endsWithAny(tool, TABLE_BLOCK_TOOLS);

export const isChartBlockTool = (tool: string): boolean =>
  endsWithAny(tool, CHART_BLOCK_TOOLS);

export const isNumberBlockTool = (tool: string): boolean =>
  endsWithAny(tool, NUMBER_BLOCK_TOOLS);

export const isPersistableBlockTool = (tool: string): boolean =>
  endsWithAny(tool, PERSISTABLE_BLOCK_TOOLS);
